import classnames from 'classnames'
import ThemeConsumer from 'embed/components/ThemeConsumer'
import * as React from 'react'
import { connect } from 'react-redux'

import { isDotDashSelector } from 'embed/selectors/config'
import { MultiProductState } from 'embed/reducers'
import { QueryParamKeys } from 'even-ts-static'

const styles = require('./styles.scss')

export interface Props {
  showApplicationHeader: boolean
  headerText: string
}

const Header: React.SFC<Props> = ({ showApplicationHeader, headerText }) => (
  <ThemeConsumer>
    {({ headlineStyles }) =>
      headerText ? (
        <div className={styles.header}>
          <div className={styles.title} style={headlineStyles}>
            {headerText}
          </div>
        </div>
      ) : showApplicationHeader ? (
        <div className={styles.header}>
          <div className={styles.title} style={headlineStyles}>
            Compare Personalized Loan Offers in Less Than 60 Seconds
          </div>
          <div className={styles.subtitle}>Some of our lending partners</div>
          <div className={styles.logos}>
            <img
              alt="SoFi"
              className={classnames(styles.logo, styles.logoSofi)}
              height="38"
              src="https://aff-tag.evenfinancial.com/images/sofi/sofi_120-1.png"
            />
            <img
              alt="Upgrade"
              className={classnames(styles.logo, styles.logoUpgrade)}
              height="18"
              src="https://aff-tag.evenfinancial.com/images/upgrade/Upgrade_120x80-1.png"
            />
            <img
              alt="Best Egg"
              className={classnames(styles.logo, styles.logoBestegg)}
              height="42"
              src="https://aff-tag.evenfinancial.com/images/bestegg/bestegg_600w-1.png"
            />
          </div>
        </div>
      ) : null
    }
  </ThemeConsumer>
)

const mapStateToProps = (state: MultiProductState) => ({
  showApplicationHeader: state.config[QueryParamKeys.ShowEmbedApplicationHeader] && !isDotDashSelector(state),
  headerText: state.config.headerText,
})

export default connect(mapStateToProps)(Header)
